import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { Observable } from 'rxjs';
import { DataService } from '../data/data.service';
import { IReKeyModel, ISendDiscountCode } from '../../interfaces/IBenefits';

@Injectable({
  providedIn: 'root'
})
export class BenefitsService {

  constructor(private data: DataService, private httpService: HttpService) { }

  reKeyZipCodeSearch(zipCode: string): Observable<IReKeyModel> {
    return this.httpService.get<IReKeyModel>(`/api/${this.data.auth0UserId.getValue()}/vendor-search/${zipCode}`);
  }

  sendDiscountCode(email: string, contractNumber: string): Observable<ISendDiscountCode> {
    return this.httpService.post<ISendDiscountCode>(`/api/${this.data.auth0UserId.getValue()}/contracts/${contractNumber}/appliancebuyline`, { email });
  }
}
